var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentsIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79998 4.0013V11.668C6.79998 13.1413 5.60664 14.3346 4.13331 14.3346C2.65998 14.3346 1.46664 13.1413 1.46664 11.668V3.33464C1.46664 2.89261 1.64224 2.46868 1.9548 2.15612C2.26736 1.84356 2.69128 1.66797 3.13331 1.66797C3.57534 1.66797 3.99926 1.84356 4.31182 2.15612C4.62438 2.46868 4.79998 2.89261 4.79998 3.33464V10.3346C4.79998 10.7013 4.49998 11.0013 4.13331 11.0013C3.76664 11.0013 3.46664 10.7013 3.46664 10.3346V4.0013H2.46664V10.3346C2.46664 10.7767 2.64224 11.2006 2.9548 11.5131C3.26736 11.8257 3.69128 12.0013 4.13331 12.0013C4.57534 12.0013 4.99926 11.8257 5.31182 11.5131C5.62438 11.2006 5.79998 10.7767 5.79998 10.3346V3.33464C5.79998 1.8613 4.60664 0.667969 3.13331 0.667969C1.65998 0.667969 0.466644 1.8613 0.466644 3.33464V11.668C0.466644 13.6946 2.10664 15.3346 4.13331 15.3346C6.15998 15.3346 7.79998 13.6946 7.79998 11.668V4.0013H6.79998Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentsIconActive);
export default __webpack_public_path__ + "static/media/attachments-icon-active.75d5596d0178f5e64a54229e5cbd3a83.svg";
export { ForwardRef as ReactComponent };